import React from "react";
import { Stack, Typography } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import { formatMoney, unformatMoney } from "@smartrr/shared/utils/formatMoney";
import { IPurchaseStateLineItem } from "@smartrr/shared/entities/PurchaseState/CustomerPurchaseLineItem";
import { CurrencyCode } from "@smartrr/shared/currencyCode";
import { ISmartrrOrderLineItem } from "@smartrr/shared/entities/OrderLineItem";

interface OrderItemVariantUndiscountedPricingProps {
  item: ISmartrrOrderLineItem;
  subscriptionItemFromItem: IPurchaseStateLineItem;
  orderCurrency: CurrencyCode;
}

export const OrderItemVariantUndiscountedPricing = ({
  item,
  subscriptionItemFromItem,
  orderCurrency,
}: OrderItemVariantUndiscountedPricingProps) => {
  return (
    <Stack
      direction="row"
      sx={{ marginBottom: "3px", flexWrap: "wrap" }}
      className={prefixClassName("order-sub-undiscounted-pricing")}
    >
      <Typography variant="caption1" sx={{ marginRight: "3px" }}>
        {formatMoney(item.price, orderCurrency)}
      </Typography>
      {+subscriptionItemFromItem?.pricingPolicy.basePrice.amount >
        +subscriptionItemFromItem?.pricingPolicy.cycleDiscounts[0].computedPrice.amount && (
        <Typography
          variant="caption1"
          sx={{
            textDecoration: "line-through",
            opacity: "70%",
          }}
        >
          {formatMoney(
            unformatMoney(subscriptionItemFromItem?.pricingPolicy.basePrice.amount, orderCurrency),
            orderCurrency
          )}
        </Typography>
      )}
    </Stack>
  );
};
